import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { regexValidators } from './validator.component';

@Component({
  standalone: false,
  selector: 'pptl-modal-passcode-inquiry',
  templateUrl: './modal-passcode-inquiry.component.html',
  styleUrls: ['./modal-passcode-inquiry.component.scss'],
})
export class ModalPasscodeInquiryComponent {
  public deliveryMethod: 'email' | 'sms' = 'email';
  public emailForm: FormGroup;
  public smsForm: FormGroup;

  constructor(public modalController: ModalController) {
    this.emailForm = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
    });

    this.smsForm = new FormGroup({
      phoneNumber: new FormControl(
        '',
        Validators.compose([Validators.pattern(regexValidators.phoneNumber), Validators.required]),
      ),
    });
  }

  onSubmit() {
    this.modalController.dismiss();
  }

  onClose() {
    this.modalController.dismiss();
  }

  isError(form: FormGroup, controlName: string, errorType: string): boolean {
    const control: AbstractControl = form.get(controlName);
    const controlHasError = control.hasError(errorType);

    return controlHasError && (control.dirty || control.touched);
  }

  getClass(form: FormGroup, controlName: string, errorType: string): string {
    return this.isError(form, controlName, errorType) || this.isError(form, controlName, 'required')
      ? 'error'
      : 'valid';
  }
}
